import axios from "axios";

import { BASE_URL as API } from "./apiBase";

const authHeaders = (token) => {
  const bearerToken =
    typeof token === "string" && token.trim() ? token.trim() : null;
  return bearerToken ? { Authorization: `Bearer ${bearerToken}` } : {};
};

export const uploadImage = async (file, folder = "general", token = null) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder", folder);

  const response = await axios.post(`${API}/api/Images/upload`, formData, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
  return response.data;
};
